// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Frfg5","info":"Note_info__2zgpD","note":"Note_note__oGtFv","actions":"Note_actions__3I8G9"};